import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import _ from "lodash";
import placeholderBackground from "../../../assets/images/placeholder-background.png";

import { config } from "../../../config";

const { SERVER_URL } = config;

const RedeemedTab = ({ history, redeemedRewards }) => {
  return (
    <div className="d-flex flex-column">
      {redeemedRewards.length > 0 ? (
        redeemedRewards.map((cart, index) => (
          <div
            key={index}
            className="bg-white rounded shadow mb-3"
            // onClick={() => history.push(`rewards/carts/${cart.id}`)}
          >
            <div className="my-2 pb-2 px-2 border-bottom w-100">
              <div className="text-muted" style={{ fontSize: "0.7rem" }}>
                Redeemed on:{" "}
                {moment(cart.createdAt).format("D MMM YYYY, hh:mm:ssa")}
                {/* &nbsp;&nbsp;
                <span className="font-weight-bold">
                  <i className="fas fa-chevron-right"></i>
                </span> */}
              </div>
            </div>

            <div id="itemDetailContainer">
              {cart.items.length > 0 &&
                cart.items.map((item, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between align-items-center mb-2 px-2"
                  >
                    <div
                      className="img-responsive"
                      style={{
                        position: "relative",
                        background: `url(${
                          item && item.reward_item.images.length > 0
                            ? `${SERVER_URL}/${item.reward_item.images[0].url}`
                            : placeholderBackground
                        }) no-repeat center center`,
                        backgroundSize: "contain",
                        height: "75px",
                        width: "75px",
                      }}
                    ></div>
                    <div className="d-flex flex-column flex-grow-1 ml-3">
                      <div className="p-0 m-0" style={{ fontSize: "0.9rem" }}>
                        {item &&
                          _.truncate(item.reward_item.name, { length: 24 })}
                      </div>
                      <div
                        className="text-brand mt-1"
                        style={{ fontSize: "0.8rem" }}
                      >
                        {item && item.reward_item.type === "redeemable"
                          ? `${
                              item.reward_item.redeem_points * item.quantity
                            } Points`
                          : "Free"}
                      </div>
                      <div
                        className="mt-1 text-muted"
                        style={{ fontSize: "0.8rem" }}
                      >
                        x{item && item.quantity}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div
              id="totalContainer"
              className="d-flex align-items-center justify-content-between my-2 pt-2 px-2 w-100 border-top"
            >
              <span className="badge badge-brand">
                {cart.is_collected == 1 && !cart.is_mailed
                  ? "Collected"
                  : !cart.is_collected && cart.is_mailed
                  ? "Mailed"
                  : cart.is_collected == 3
                  ? "Cancelled"
                  : "Pending"}
              </span>
              <div style={{ fontSize: "0.8rem" }}>
                {cart.items.reduce((total, item) => total + item.quantity, 0)}{" "}
                item
                {cart.items.reduce((total, item) => total + item.quantity, 0) >
                  1 && "s"}
                , Total:{" "}
                <span className="font-weight-bold">
                  {cart.total === 0 ? "Free" : `${cart.total} Points`}
                </span>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="bg-white rounded shadow mb-3 py-2 px-3">
          No items redeemed.
        </div>
      )}
    </div>
  );
};

export default withRouter(RedeemedTab);
